import { BuildingLibraryIcon, DevicePhoneMobileIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'
import { usePayoutMethodLabels } from 'shared/hooks'
import type { WithClassName } from 'shared/types/general.types'
import type {
	PayoutDestination as PayoutDestinationItem,
	PayoutMethodKind
} from 'shared/types/payout.types'
import { cn } from 'utils/style'

type PayoutDestinationProps = WithClassName<{
	destination: PayoutDestinationItem | null | undefined
}>

const icons: Record<PayoutMethodKind, typeof BuildingLibraryIcon> = {
	bank: BuildingLibraryIcon,
	bizum: DevicePhoneMobileIcon
}

export const PayoutDestination = ({ destination, className }: PayoutDestinationProps) => {
	const { t } = useTranslation()
	const payoutMethodLabels = usePayoutMethodLabels()

	if (!destination) {
		return (
			<span className={cn('block truncate text-[12px] text-muted-foreground', className)}>
				{t('No payout method')}
			</span>
		)
	}

	const Icon = icons[destination.kind] ?? BuildingLibraryIcon

	return (
		<span className={cn('flex min-w-0 items-center gap-2', className)}>
			<Icon aria-hidden className="h-4 w-4 shrink-0 text-muted-foreground" />
			<span className="min-w-0 leading-tight">
				<span className="block truncate text-[12px] font-medium tabular-nums text-foreground">
					{destination.details}
				</span>
				<span className="block truncate text-[11px] text-muted-foreground">
					{payoutMethodLabels[destination.kind]}
				</span>
			</span>
		</span>
	)
}
